import { BaseObject } from "../core/BaseObject";

export class Customer extends BaseObject {
    customerId: number;
    name: string;
    inn: string;
    externalCode: string;
}